import geoConfirm from 'services/utils/confirm';

import ButtonTooltip from '../../ButtonTooltip';

import Icon from '@map/components/Icons';
/**
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional
 */
import { useEffect } from 'react';
/**
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 */
import { useModule } from 'views/MapView/hooks';

/**
 * Função responsável por reiniciar o mapa e suas configurações 
 * para o default(padrão).
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Setar o estado
 * @param {*} props Resto 
 * @returns Uma pergunta, pedindo confirmação 
 * para resetar o mapa. 
 */
export const ResetMap = ({ mapContext, isActive, setIsActive, ...props }) => {
  const { resetModule } = useModule();

  // Auto-disable da ferramenta
  useEffect(() => {
    isActive && setIsActive();
  }, [isActive, setIsActive]);

  return (
    <ButtonTooltip
      tooltip={ResetMap.properties.alias}
      description={ResetMap.properties.description}
      onClick={() => {
        setIsActive();
        // eslint-disable-next-line no-restricted-globals
        geoConfirm({
          message:
            'Todas as alterações serão perdidas. Deseja realmente reiniciar o Mapa?',
          callback: (confirmed) => {
            if (confirmed) resetModule();
          },
        });
      }}
      active={isActive}
    >
      <Icon
        i="map-toolbar-refresh"
        width="18"
        height="18"
        style={{ verticalAlign: 'middle' }}
      />
    </ButtonTooltip>
  );
};

ResetMap.properties = {
  id: 'CPN-TB-N-RESET-MAP',
  alias: 'Reiniciar Mapa',
  description: 'Reinicia o mapa com a configuração original.',
};

export default ResetMap;
